var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup37(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1897,
    height: 180.57,
    viewBox: "0 0 1897 180.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        opacity: 0.385;\n      }\n\n      .cls-3 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-4 {\n        fill: #061196;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    className: "cls-1",
    width: 621.847,
    height: 180.57
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    className: "cls-2",
    transform: "translate(-23 -5189.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(23 5189.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    className: "cls-4",
    d: "M0,39.9V110.28a8.381,8.381,0,0,0,2.455,5.927L15.97,129.722a8.38,8.38,0,0,1,2.455,5.926v29.207a8.382,8.382,0,0,0,2.455,5.927l7.179,7.179a8.38,8.38,0,0,0,5.926,2.455H74.271a8.382,8.382,0,0,0,5.927-2.455l4.788-4.789a8.381,8.381,0,0,0,2.455-5.927V112.715a8.382,8.382,0,0,0-2.455-5.927L65.766,87.568a8.382,8.382,0,0,1-2.455-5.927V12.893a8.38,8.38,0,0,0-2.455-5.926L56.345,2.456A8.379,8.379,0,0,0,50.418,0H8.381A8.381,8.381,0,0,0,0,8.382Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    className: "cls-4",
    d: "M119.6,173.586V108.574a6.828,6.828,0,0,1,2-4.829l10.608-10.609a6.829,6.829,0,0,0,2-4.829V67.992a6.829,6.829,0,0,0-2-4.829l-20.7-20.7a6.832,6.832,0,0,1-2-4.829V6.83A6.829,6.829,0,0,1,116.342,0h48.374a6.829,6.829,0,0,1,6.829,6.83V107.553a6.83,6.83,0,0,1-2,4.829l-24.523,24.523a6.829,6.829,0,0,0-2,4.829v31.851a6.829,6.829,0,0,1-6.829,6.83H126.43a6.83,6.83,0,0,1-6.83-6.83",
    transform: "translate(-17.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    className: "cls-4",
    d: "M203.9,2.863V123.486a2.741,2.741,0,0,0,.8,1.939l4.062,4.062a2.742,2.742,0,0,1,.8,1.94v46.267a2.743,2.743,0,0,0,2.743,2.742h11.243a2.742,2.742,0,0,0,2.742-2.742V63.96a2.743,2.743,0,0,0-.8-1.94L215.215,51.738a2.743,2.743,0,0,1-.8-1.94V5.619a2.743,2.743,0,0,0-.8-1.94l-2.67-2.67a2.739,2.739,0,0,0-1.84-.8L206.746.123a2.742,2.742,0,0,0-2.841,2.74",
    transform: "translate(-33.071 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    className: "cls-4",
    d: "M297.933,84.885l4.294-4.294a5.752,5.752,0,0,0,1.685-4.068V69.588a5.754,5.754,0,0,0-1.685-4.068L296.2,59.494a5.754,5.754,0,0,1-1.685-4.068V26.57A5.757,5.757,0,0,1,296.2,22.5l4.212-4.211a5.753,5.753,0,0,0,1.685-4.068V5.937A5.753,5.753,0,0,0,296.346.184h-56.4a5.753,5.753,0,0,0-5.753,5.753V38.454a5.752,5.752,0,0,0,1.681,4.064l42.283,42.363a5.752,5.752,0,0,0,4.072,1.689h11.635a5.752,5.752,0,0,0,4.068-1.685",
    transform: "translate(-37.983 -0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    className: "cls-4",
    d: "M279.505,190.561V125.018a7.018,7.018,0,0,0-2.055-4.962l-13.127-13.126a7.015,7.015,0,0,0-4.961-2.055h-3.134a7.017,7.017,0,0,0-7.018,7.018v65.144a7.02,7.02,0,0,0,2.023,4.93l13.351,13.526a7.018,7.018,0,0,0,4.994,2.088h2.909a7.017,7.017,0,0,0,7.018-7.018",
    transform: "translate(-40.418 -17.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    className: "cls-4",
    d: "M332.03,74.912l10.129-10.129a6.663,6.663,0,0,1,4.711-1.951h55.777a6.664,6.664,0,0,1,4.711,1.951l3.509,3.509A6.664,6.664,0,0,1,412.818,73v6.376a6.665,6.665,0,0,1-1.951,4.712l-7.821,7.821a6.66,6.66,0,0,0-1.952,4.711v70.956a6.659,6.659,0,0,1-1.951,4.711l-16.518,16.518a6.66,6.66,0,0,1-4.711,1.952h-59.53a6.663,6.663,0,0,1-6.662-6.663v-63.96a6.661,6.661,0,0,1,1.953-4.713l14.451-14.442a6.663,6.663,0,0,0,1.953-4.713V79.623a6.663,6.663,0,0,1,1.951-4.711",
    transform: "translate(-50.557 -10.19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    className: "cls-4",
    d: "M415.388,4.057V25.046a3.873,3.873,0,0,1-3.873,3.872H400.473a3.874,3.874,0,0,1-2.738-1.134l-7.5-7.5a3.871,3.871,0,0,0-2.739-1.135H376.974a3.871,3.871,0,0,0-2.739,1.135L359.867,34.648a3.866,3.866,0,0,1-2.738,1.134H331.448a3.873,3.873,0,0,1-2.726-6.625L356.831,1.306A3.873,3.873,0,0,1,359.557.184h51.958a3.874,3.874,0,0,1,3.873,3.873",
    transform: "translate(-53.127 -0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    className: "cls-4",
    d: "M448.9,3.863V120.947a3.675,3.675,0,0,0,1.069,2.59l11.613,11.674a3.672,3.672,0,0,0,6.276-2.59V9.956a3.671,3.671,0,0,0-1.069-2.59l-6.066-6.1A3.674,3.674,0,0,0,458.117.186L452.57.191A3.672,3.672,0,0,0,448.9,3.863",
    transform: "translate(-72.805 -0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    className: "cls-4",
    d: "M450,162.094l11.613,11.439a3.673,3.673,0,0,0,5.154-5.233l-11.613-11.439A3.672,3.672,0,0,0,450,162.094",
    transform: "translate(-72.806 -25.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    className: "cls-4",
    d: "M450.008,177.736l11.613,11.439a3.673,3.673,0,0,0,5.154-5.233L455.162,172.5a3.672,3.672,0,0,0-5.154,5.232",
    transform: "translate(-72.807 -27.805)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    className: "cls-4",
    d: "M450,193.305l11.613,11.439a3.672,3.672,0,0,0,5.154-5.232l-11.613-11.439A3.672,3.672,0,0,0,450,193.305",
    transform: "translate(-72.806 -30.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    className: "cls-4",
    d: "M542.5.192,503.922.186a11.368,11.368,0,0,0-8.04,3.329l-.388.388a11.366,11.366,0,0,0-3.329,8.039V69.427a11.368,11.368,0,0,0,3.329,8.039l34.6,34.6a11.366,11.366,0,0,1,3.329,8.038v17.954c0,10.632,8.317,19.779,18.948,19.945a19.254,19.254,0,0,0,19.563-19.253V29.623a11.367,11.367,0,0,0-3.329-8.039L550.538,3.522A11.371,11.371,0,0,0,542.5.192m16.543,152.117c-12.714,5.294-24.789-6.78-19.5-19.5a13.278,13.278,0,0,1,7.121-7.12c12.714-5.294,24.788,6.781,19.5,19.5a13.283,13.283,0,0,1-7.12,7.12",
    transform: "translate(-79.822 -0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    className: "cls-4",
    d: "M516.367,147.5a5,5,0,0,0-3.533-1.464H497.111a5,5,0,0,0-3.533,1.464L491,150.074a5,5,0,0,0-1.464,3.533v42.765A5,5,0,0,0,491,199.9l2.577,2.577a5,5,0,0,0,3.533,1.464h15.723a4.993,4.993,0,0,0,3.533-1.464l2.577-2.577a5,5,0,0,0,1.464-3.533V153.607a5,5,0,0,0-1.464-3.533Z",
    transform: "translate(-79.396 -23.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    className: "cls-4",
    d: "M613.095.185h-5.51a4.245,4.245,0,0,0-3,1.244L603.04,2.97a4.247,4.247,0,0,0-1.244,3V36.788a4.245,4.245,0,0,0,1.244,3l1.542,1.542a4.246,4.246,0,0,0,3,1.243h1.263a4.246,4.246,0,0,0,4.247-4.247v-5.65a11.3,11.3,0,0,1,8.3-10.895,4.235,4.235,0,0,0,3-4.126V5.973a4.246,4.246,0,0,0-1.244-3l-1.541-1.541a4.247,4.247,0,0,0-3-1.244Z",
    transform: "translate(-97.603 -0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    className: "cls-4",
    d: "M651.829,1.428a4.246,4.246,0,0,0-3-1.244H637.8a4.246,4.246,0,0,0-3,1.244L633.261,2.97a4.245,4.245,0,0,0-1.244,3V17.657a4.236,4.236,0,0,0,3,4.127,11.3,11.3,0,0,1,8.3,10.895v5.65a4.247,4.247,0,0,0,4.247,4.247h1.263a4.246,4.246,0,0,0,3-1.244l1.542-1.541a4.25,4.25,0,0,0,1.243-3V5.972a4.248,4.248,0,0,0-1.243-3Z",
    transform: "translate(-102.504 -0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    className: "cls-4",
    d: "M613.095,63.928v-5.65a4.246,4.246,0,0,0-4.247-4.247h-1.263a4.243,4.243,0,0,0-3,1.244l-1.542,1.541a4.247,4.247,0,0,0-1.244,3V90.634a4.247,4.247,0,0,0,1.244,3l1.542,1.542a4.248,4.248,0,0,0,3,1.243H618.6a4.249,4.249,0,0,0,3-1.243l1.541-1.542a4.246,4.246,0,0,0,1.244-3V78.949a4.236,4.236,0,0,0-3-4.126,11.3,11.3,0,0,1-8.3-10.895",
    transform: "translate(-97.603 -8.763)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    className: "cls-4",
    d: "M647.562,54.031a4.247,4.247,0,0,0-4.247,4.247v5.65a11.3,11.3,0,0,1-8.3,10.895,4.236,4.236,0,0,0-3,4.126V90.634a4.246,4.246,0,0,0,1.244,3l1.542,1.542a4.246,4.246,0,0,0,3,1.243h11.021a4.246,4.246,0,0,0,3-1.243l1.542-1.542a4.246,4.246,0,0,0,1.244-3V59.819a4.246,4.246,0,0,0-1.244-3l-1.542-1.541a4.243,4.243,0,0,0-3-1.244Z",
    transform: "translate(-102.504 -8.763)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    className: "cls-4",
    d: "M627.217,123.985H613.6a10.971,10.971,0,0,0-10.97,10.97V196.53a4.148,4.148,0,0,0,4.148,4.148h32.586a4.148,4.148,0,0,0,4.148-4.148V140.281a4.149,4.149,0,0,0-1.215-2.933L630.15,125.2a4.151,4.151,0,0,0-2.933-1.215M615.06,161.5a7.853,7.853,0,1,1,6.512-6.513,7.858,7.858,0,0,1-6.512,6.513m0-18.47a7.853,7.853,0,1,1,6.513-6.513,7.858,7.858,0,0,1-6.513,6.513",
    transform: "translate(-97.738 -20.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    className: "cls-4",
    d: "M680.264,13.384v26.98A4.154,4.154,0,0,0,681.48,43.3l2.569,2.569a4.153,4.153,0,0,1,1.217,2.937V161.684a4.156,4.156,0,0,1-1.156,2.876l-2.689,2.8a4.157,4.157,0,0,0-1.156,2.876v5.9a4.154,4.154,0,0,0,4.154,4.154h35.437a4.154,4.154,0,0,0,4.154-4.154V169.76a4.154,4.154,0,0,0-1.216-2.937l-13.749-13.749a4.157,4.157,0,0,1-1.216-2.937V38.535a4.154,4.154,0,0,0-1.216-2.937l-9.372-9.372a4.153,4.153,0,0,1-1.217-2.937V4.339A4.154,4.154,0,0,0,691.868.185h-7.45a4.154,4.154,0,0,0-4.154,4.154Z",
    transform: "translate(-110.329 -0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    className: "cls-4",
    d: "M720.379,152.9l-2.7-2.7a4.433,4.433,0,0,1-1.3-3.135V35.929a4.437,4.437,0,0,0-1.3-3.135l-9.587-9.587a4.431,4.431,0,0,1-1.3-3.135V4.619A4.433,4.433,0,0,1,708.626.185h23a4.433,4.433,0,0,1,4.434,4.434V126.891a4.434,4.434,0,0,1-1.3,3.135l-5.45,5.451a4.434,4.434,0,0,0-1.3,3.11l-.062,11.2a4.434,4.434,0,0,1-7.569,3.111",
    transform: "translate(-114.21 -0.03)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(660.576 5189.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33-2",
    "data-name": "Group 33",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43-2",
    "data-name": "Path 43",
    className: "cls-4",
    d: "M0,39.9V110.28a8.381,8.381,0,0,0,2.455,5.927L15.97,129.722a8.38,8.38,0,0,1,2.455,5.926v29.207a8.382,8.382,0,0,0,2.455,5.927l7.179,7.179a8.38,8.38,0,0,0,5.926,2.455H74.271a8.382,8.382,0,0,0,5.927-2.455l4.788-4.789a8.381,8.381,0,0,0,2.455-5.927V112.715a8.382,8.382,0,0,0-2.455-5.927L65.766,87.568a8.382,8.382,0,0,1-2.455-5.927V12.893a8.38,8.38,0,0,0-2.455-5.926L56.345,2.456A8.379,8.379,0,0,0,50.418,0H8.381A8.381,8.381,0,0,0,0,8.382Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44-2",
    "data-name": "Path 44",
    className: "cls-4",
    d: "M119.6,173.586V108.574a6.828,6.828,0,0,1,2-4.829l10.608-10.609a6.829,6.829,0,0,0,2-4.829V67.992a6.829,6.829,0,0,0-2-4.829l-20.7-20.7a6.832,6.832,0,0,1-2-4.829V6.83A6.829,6.829,0,0,1,116.342,0h48.374a6.829,6.829,0,0,1,6.829,6.83V107.553a6.83,6.83,0,0,1-2,4.829l-24.523,24.523a6.829,6.829,0,0,0-2,4.829v31.851a6.829,6.829,0,0,1-6.829,6.83H126.43a6.83,6.83,0,0,1-6.83-6.83",
    transform: "translate(-17.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45-2",
    "data-name": "Path 45",
    className: "cls-4",
    d: "M203.9,2.863V123.486a2.741,2.741,0,0,0,.8,1.939l4.062,4.062a2.742,2.742,0,0,1,.8,1.94v46.267a2.743,2.743,0,0,0,2.743,2.742h11.243a2.742,2.742,0,0,0,2.742-2.742V63.96a2.743,2.743,0,0,0-.8-1.94L215.215,51.738a2.743,2.743,0,0,1-.8-1.94V5.619a2.743,2.743,0,0,0-.8-1.94l-2.67-2.67a2.739,2.739,0,0,0-1.84-.8L206.746.123a2.742,2.742,0,0,0-2.841,2.74",
    transform: "translate(-33.071 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46-2",
    "data-name": "Path 46",
    className: "cls-4",
    d: "M297.933,84.885l4.294-4.294a5.752,5.752,0,0,0,1.685-4.068V69.588a5.754,5.754,0,0,0-1.685-4.068L296.2,59.494a5.754,5.754,0,0,1-1.685-4.068V26.57A5.757,5.757,0,0,1,296.2,22.5l4.212-4.211a5.753,5.753,0,0,0,1.685-4.068V5.937A5.753,5.753,0,0,0,296.346.184h-56.4a5.753,5.753,0,0,0-5.753,5.753V38.454a5.752,5.752,0,0,0,1.681,4.064l42.283,42.363a5.752,5.752,0,0,0,4.072,1.689h11.635a5.752,5.752,0,0,0,4.068-1.685",
    transform: "translate(-37.983 -0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47-2",
    "data-name": "Path 47",
    className: "cls-4",
    d: "M279.505,190.561V125.018a7.018,7.018,0,0,0-2.055-4.962l-13.127-13.126a7.015,7.015,0,0,0-4.961-2.055h-3.134a7.017,7.017,0,0,0-7.018,7.018v65.144a7.02,7.02,0,0,0,2.023,4.93l13.351,13.526a7.018,7.018,0,0,0,4.994,2.088h2.909a7.017,7.017,0,0,0,7.018-7.018",
    transform: "translate(-40.418 -17.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48-2",
    "data-name": "Path 48",
    className: "cls-4",
    d: "M332.03,74.912l10.129-10.129a6.663,6.663,0,0,1,4.711-1.951h55.777a6.664,6.664,0,0,1,4.711,1.951l3.509,3.509A6.664,6.664,0,0,1,412.818,73v6.376a6.665,6.665,0,0,1-1.951,4.712l-7.821,7.821a6.66,6.66,0,0,0-1.952,4.711v70.956a6.659,6.659,0,0,1-1.951,4.711l-16.518,16.518a6.66,6.66,0,0,1-4.711,1.952h-59.53a6.663,6.663,0,0,1-6.662-6.663v-63.96a6.661,6.661,0,0,1,1.953-4.713l14.451-14.442a6.663,6.663,0,0,0,1.953-4.713V79.623a6.663,6.663,0,0,1,1.951-4.711",
    transform: "translate(-50.557 -10.19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49-2",
    "data-name": "Path 49",
    className: "cls-4",
    d: "M415.388,4.057V25.046a3.873,3.873,0,0,1-3.873,3.872H400.473a3.874,3.874,0,0,1-2.738-1.134l-7.5-7.5a3.871,3.871,0,0,0-2.739-1.135H376.974a3.871,3.871,0,0,0-2.739,1.135L359.867,34.648a3.866,3.866,0,0,1-2.738,1.134H331.448a3.873,3.873,0,0,1-2.726-6.625L356.831,1.306A3.873,3.873,0,0,1,359.557.184h51.958a3.874,3.874,0,0,1,3.873,3.873",
    transform: "translate(-53.127 -0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50-2",
    "data-name": "Path 50",
    className: "cls-4",
    d: "M448.9,3.863V120.947a3.675,3.675,0,0,0,1.069,2.59l11.613,11.674a3.672,3.672,0,0,0,6.276-2.59V9.956a3.671,3.671,0,0,0-1.069-2.59l-6.066-6.1A3.674,3.674,0,0,0,458.117.186L452.57.191A3.672,3.672,0,0,0,448.9,3.863",
    transform: "translate(-72.805 -0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-2",
    "data-name": "Path 51",
    className: "cls-4",
    d: "M450,162.094l11.613,11.439a3.673,3.673,0,0,0,5.154-5.233l-11.613-11.439A3.672,3.672,0,0,0,450,162.094",
    transform: "translate(-72.806 -25.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52-2",
    "data-name": "Path 52",
    className: "cls-4",
    d: "M450.008,177.736l11.613,11.439a3.673,3.673,0,0,0,5.154-5.233L455.162,172.5a3.672,3.672,0,0,0-5.154,5.232",
    transform: "translate(-72.807 -27.805)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53-2",
    "data-name": "Path 53",
    className: "cls-4",
    d: "M450,193.305l11.613,11.439a3.672,3.672,0,0,0,5.154-5.232l-11.613-11.439A3.672,3.672,0,0,0,450,193.305",
    transform: "translate(-72.806 -30.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54-2",
    "data-name": "Path 54",
    className: "cls-4",
    d: "M542.5.192,503.922.186a11.368,11.368,0,0,0-8.04,3.329l-.388.388a11.366,11.366,0,0,0-3.329,8.039V69.427a11.368,11.368,0,0,0,3.329,8.039l34.6,34.6a11.366,11.366,0,0,1,3.329,8.038v17.954c0,10.632,8.317,19.779,18.948,19.945a19.254,19.254,0,0,0,19.563-19.253V29.623a11.367,11.367,0,0,0-3.329-8.039L550.538,3.522A11.371,11.371,0,0,0,542.5.192m16.543,152.117c-12.714,5.294-24.789-6.78-19.5-19.5a13.278,13.278,0,0,1,7.121-7.12c12.714-5.294,24.788,6.781,19.5,19.5a13.283,13.283,0,0,1-7.12,7.12",
    transform: "translate(-79.822 -0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55-2",
    "data-name": "Path 55",
    className: "cls-4",
    d: "M516.367,147.5a5,5,0,0,0-3.533-1.464H497.111a5,5,0,0,0-3.533,1.464L491,150.074a5,5,0,0,0-1.464,3.533v42.765A5,5,0,0,0,491,199.9l2.577,2.577a5,5,0,0,0,3.533,1.464h15.723a4.993,4.993,0,0,0,3.533-1.464l2.577-2.577a5,5,0,0,0,1.464-3.533V153.607a5,5,0,0,0-1.464-3.533Z",
    transform: "translate(-79.396 -23.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56-2",
    "data-name": "Path 56",
    className: "cls-4",
    d: "M613.095.185h-5.51a4.245,4.245,0,0,0-3,1.244L603.04,2.97a4.247,4.247,0,0,0-1.244,3V36.788a4.245,4.245,0,0,0,1.244,3l1.542,1.542a4.246,4.246,0,0,0,3,1.243h1.263a4.246,4.246,0,0,0,4.247-4.247v-5.65a11.3,11.3,0,0,1,8.3-10.895,4.235,4.235,0,0,0,3-4.126V5.973a4.246,4.246,0,0,0-1.244-3l-1.541-1.541a4.247,4.247,0,0,0-3-1.244Z",
    transform: "translate(-97.603 -0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57-2",
    "data-name": "Path 57",
    className: "cls-4",
    d: "M651.829,1.428a4.246,4.246,0,0,0-3-1.244H637.8a4.246,4.246,0,0,0-3,1.244L633.261,2.97a4.245,4.245,0,0,0-1.244,3V17.657a4.236,4.236,0,0,0,3,4.127,11.3,11.3,0,0,1,8.3,10.895v5.65a4.247,4.247,0,0,0,4.247,4.247h1.263a4.246,4.246,0,0,0,3-1.244l1.542-1.541a4.25,4.25,0,0,0,1.243-3V5.972a4.248,4.248,0,0,0-1.243-3Z",
    transform: "translate(-102.504 -0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58-2",
    "data-name": "Path 58",
    className: "cls-4",
    d: "M613.095,63.928v-5.65a4.246,4.246,0,0,0-4.247-4.247h-1.263a4.243,4.243,0,0,0-3,1.244l-1.542,1.541a4.247,4.247,0,0,0-1.244,3V90.634a4.247,4.247,0,0,0,1.244,3l1.542,1.542a4.248,4.248,0,0,0,3,1.243H618.6a4.249,4.249,0,0,0,3-1.243l1.541-1.542a4.246,4.246,0,0,0,1.244-3V78.949a4.236,4.236,0,0,0-3-4.126,11.3,11.3,0,0,1-8.3-10.895",
    transform: "translate(-97.603 -8.763)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59-2",
    "data-name": "Path 59",
    className: "cls-4",
    d: "M647.562,54.031a4.247,4.247,0,0,0-4.247,4.247v5.65a11.3,11.3,0,0,1-8.3,10.895,4.236,4.236,0,0,0-3,4.126V90.634a4.246,4.246,0,0,0,1.244,3l1.542,1.542a4.246,4.246,0,0,0,3,1.243h11.021a4.246,4.246,0,0,0,3-1.243l1.542-1.542a4.246,4.246,0,0,0,1.244-3V59.819a4.246,4.246,0,0,0-1.244-3l-1.542-1.541a4.243,4.243,0,0,0-3-1.244Z",
    transform: "translate(-102.504 -8.763)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60-2",
    "data-name": "Path 60",
    className: "cls-4",
    d: "M627.217,123.985H613.6a10.971,10.971,0,0,0-10.97,10.97V196.53a4.148,4.148,0,0,0,4.148,4.148h32.586a4.148,4.148,0,0,0,4.148-4.148V140.281a4.149,4.149,0,0,0-1.215-2.933L630.15,125.2a4.151,4.151,0,0,0-2.933-1.215M615.06,161.5a7.853,7.853,0,1,1,6.512-6.513,7.858,7.858,0,0,1-6.512,6.513m0-18.47a7.853,7.853,0,1,1,6.513-6.513,7.858,7.858,0,0,1-6.513,6.513",
    transform: "translate(-97.738 -20.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61-2",
    "data-name": "Path 61",
    className: "cls-4",
    d: "M680.264,13.384v26.98A4.154,4.154,0,0,0,681.48,43.3l2.569,2.569a4.153,4.153,0,0,1,1.217,2.937V161.684a4.156,4.156,0,0,1-1.156,2.876l-2.689,2.8a4.157,4.157,0,0,0-1.156,2.876v5.9a4.154,4.154,0,0,0,4.154,4.154h35.437a4.154,4.154,0,0,0,4.154-4.154V169.76a4.154,4.154,0,0,0-1.216-2.937l-13.749-13.749a4.157,4.157,0,0,1-1.216-2.937V38.535a4.154,4.154,0,0,0-1.216-2.937l-9.372-9.372a4.153,4.153,0,0,1-1.217-2.937V4.339A4.154,4.154,0,0,0,691.868.185h-7.45a4.154,4.154,0,0,0-4.154,4.154Z",
    transform: "translate(-110.329 -0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62-2",
    "data-name": "Path 62",
    className: "cls-4",
    d: "M720.379,152.9l-2.7-2.7a4.433,4.433,0,0,1-1.3-3.135V35.929a4.437,4.437,0,0,0-1.3-3.135l-9.587-9.587a4.431,4.431,0,0,1-1.3-3.135V4.619A4.433,4.433,0,0,1,708.626.185h23a4.433,4.433,0,0,1,4.434,4.434V126.891a4.434,4.434,0,0,1-1.3,3.135l-5.45,5.451a4.434,4.434,0,0,0-1.3,3.11l-.062,11.2a4.434,4.434,0,0,1-7.569,3.111",
    transform: "translate(-114.21 -0.03)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(1298.153 5189.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33-3",
    "data-name": "Group 33",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43-3",
    "data-name": "Path 43",
    className: "cls-4",
    d: "M0,39.9V110.28a8.381,8.381,0,0,0,2.455,5.927L15.97,129.722a8.38,8.38,0,0,1,2.455,5.926v29.207a8.382,8.382,0,0,0,2.455,5.927l7.179,7.179a8.38,8.38,0,0,0,5.926,2.455H74.271a8.382,8.382,0,0,0,5.927-2.455l4.788-4.789a8.381,8.381,0,0,0,2.455-5.927V112.715a8.382,8.382,0,0,0-2.455-5.927L65.766,87.568a8.382,8.382,0,0,1-2.455-5.927V12.893a8.38,8.38,0,0,0-2.455-5.926L56.345,2.456A8.379,8.379,0,0,0,50.418,0H8.381A8.381,8.381,0,0,0,0,8.382Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44-3",
    "data-name": "Path 44",
    className: "cls-4",
    d: "M119.6,173.586V108.574a6.828,6.828,0,0,1,2-4.829l10.608-10.609a6.829,6.829,0,0,0,2-4.829V67.992a6.829,6.829,0,0,0-2-4.829l-20.7-20.7a6.832,6.832,0,0,1-2-4.829V6.83A6.829,6.829,0,0,1,116.342,0h48.374a6.829,6.829,0,0,1,6.829,6.83V107.553a6.83,6.83,0,0,1-2,4.829l-24.523,24.523a6.829,6.829,0,0,0-2,4.829v31.851a6.829,6.829,0,0,1-6.829,6.83H126.43a6.83,6.83,0,0,1-6.83-6.83",
    transform: "translate(-17.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45-3",
    "data-name": "Path 45",
    className: "cls-4",
    d: "M203.9,2.863V123.486a2.741,2.741,0,0,0,.8,1.939l4.062,4.062a2.742,2.742,0,0,1,.8,1.94v46.267a2.743,2.743,0,0,0,2.743,2.742h11.243a2.742,2.742,0,0,0,2.742-2.742V63.96a2.743,2.743,0,0,0-.8-1.94L215.215,51.738a2.743,2.743,0,0,1-.8-1.94V5.619a2.743,2.743,0,0,0-.8-1.94l-2.67-2.67a2.739,2.739,0,0,0-1.84-.8L206.746.123a2.742,2.742,0,0,0-2.841,2.74",
    transform: "translate(-33.071 -0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46-3",
    "data-name": "Path 46",
    className: "cls-4",
    d: "M297.933,84.885l4.294-4.294a5.752,5.752,0,0,0,1.685-4.068V69.588a5.754,5.754,0,0,0-1.685-4.068L296.2,59.494a5.754,5.754,0,0,1-1.685-4.068V26.57A5.757,5.757,0,0,1,296.2,22.5l4.212-4.211a5.753,5.753,0,0,0,1.685-4.068V5.937A5.753,5.753,0,0,0,296.346.184h-56.4a5.753,5.753,0,0,0-5.753,5.753V38.454a5.752,5.752,0,0,0,1.681,4.064l42.283,42.363a5.752,5.752,0,0,0,4.072,1.689h11.635a5.752,5.752,0,0,0,4.068-1.685",
    transform: "translate(-37.983 -0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47-3",
    "data-name": "Path 47",
    className: "cls-4",
    d: "M279.505,190.561V125.018a7.018,7.018,0,0,0-2.055-4.962l-13.127-13.126a7.015,7.015,0,0,0-4.961-2.055h-3.134a7.017,7.017,0,0,0-7.018,7.018v65.144a7.02,7.02,0,0,0,2.023,4.93l13.351,13.526a7.018,7.018,0,0,0,4.994,2.088h2.909a7.017,7.017,0,0,0,7.018-7.018",
    transform: "translate(-40.418 -17.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48-3",
    "data-name": "Path 48",
    className: "cls-4",
    d: "M332.03,74.912l10.129-10.129a6.663,6.663,0,0,1,4.711-1.951h55.777a6.664,6.664,0,0,1,4.711,1.951l3.509,3.509A6.664,6.664,0,0,1,412.818,73v6.376a6.665,6.665,0,0,1-1.951,4.712l-7.821,7.821a6.66,6.66,0,0,0-1.952,4.711v70.956a6.659,6.659,0,0,1-1.951,4.711l-16.518,16.518a6.66,6.66,0,0,1-4.711,1.952h-59.53a6.663,6.663,0,0,1-6.662-6.663v-63.96a6.661,6.661,0,0,1,1.953-4.713l14.451-14.442a6.663,6.663,0,0,0,1.953-4.713V79.623a6.663,6.663,0,0,1,1.951-4.711",
    transform: "translate(-50.557 -10.19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49-3",
    "data-name": "Path 49",
    className: "cls-4",
    d: "M415.388,4.057V25.046a3.873,3.873,0,0,1-3.873,3.872H400.473a3.874,3.874,0,0,1-2.738-1.134l-7.5-7.5a3.871,3.871,0,0,0-2.739-1.135H376.974a3.871,3.871,0,0,0-2.739,1.135L359.867,34.648a3.866,3.866,0,0,1-2.738,1.134H331.448a3.873,3.873,0,0,1-2.726-6.625L356.831,1.306A3.873,3.873,0,0,1,359.557.184h51.958a3.874,3.874,0,0,1,3.873,3.873",
    transform: "translate(-53.127 -0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50-3",
    "data-name": "Path 50",
    className: "cls-4",
    d: "M448.9,3.863V120.947a3.675,3.675,0,0,0,1.069,2.59l11.613,11.674a3.672,3.672,0,0,0,6.276-2.59V9.956a3.671,3.671,0,0,0-1.069-2.59l-6.066-6.1A3.674,3.674,0,0,0,458.117.186L452.57.191A3.672,3.672,0,0,0,448.9,3.863",
    transform: "translate(-72.805 -0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-3",
    "data-name": "Path 51",
    className: "cls-4",
    d: "M450,162.094l11.613,11.439a3.673,3.673,0,0,0,5.154-5.233l-11.613-11.439A3.672,3.672,0,0,0,450,162.094",
    transform: "translate(-72.806 -25.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52-3",
    "data-name": "Path 52",
    className: "cls-4",
    d: "M450.008,177.736l11.613,11.439a3.673,3.673,0,0,0,5.154-5.233L455.162,172.5a3.672,3.672,0,0,0-5.154,5.232",
    transform: "translate(-72.807 -27.805)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53-3",
    "data-name": "Path 53",
    className: "cls-4",
    d: "M450,193.305l11.613,11.439a3.672,3.672,0,0,0,5.154-5.232l-11.613-11.439A3.672,3.672,0,0,0,450,193.305",
    transform: "translate(-72.806 -30.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54-3",
    "data-name": "Path 54",
    className: "cls-4",
    d: "M542.5.192,503.922.186a11.368,11.368,0,0,0-8.04,3.329l-.388.388a11.366,11.366,0,0,0-3.329,8.039V69.427a11.368,11.368,0,0,0,3.329,8.039l34.6,34.6a11.366,11.366,0,0,1,3.329,8.038v17.954c0,10.632,8.317,19.779,18.948,19.945a19.254,19.254,0,0,0,19.563-19.253V29.623a11.367,11.367,0,0,0-3.329-8.039L550.538,3.522A11.371,11.371,0,0,0,542.5.192m16.543,152.117c-12.714,5.294-24.789-6.78-19.5-19.5a13.278,13.278,0,0,1,7.121-7.12c12.714-5.294,24.788,6.781,19.5,19.5a13.283,13.283,0,0,1-7.12,7.12",
    transform: "translate(-79.822 -0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55-3",
    "data-name": "Path 55",
    className: "cls-4",
    d: "M516.367,147.5a5,5,0,0,0-3.533-1.464H497.111a5,5,0,0,0-3.533,1.464L491,150.074a5,5,0,0,0-1.464,3.533v42.765A5,5,0,0,0,491,199.9l2.577,2.577a5,5,0,0,0,3.533,1.464h15.723a4.993,4.993,0,0,0,3.533-1.464l2.577-2.577a5,5,0,0,0,1.464-3.533V153.607a5,5,0,0,0-1.464-3.533Z",
    transform: "translate(-79.396 -23.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56-3",
    "data-name": "Path 56",
    className: "cls-4",
    d: "M613.095.185h-5.51a4.245,4.245,0,0,0-3,1.244L603.04,2.97a4.247,4.247,0,0,0-1.244,3V36.788a4.245,4.245,0,0,0,1.244,3l1.542,1.542a4.246,4.246,0,0,0,3,1.243h1.263a4.246,4.246,0,0,0,4.247-4.247v-5.65a11.3,11.3,0,0,1,8.3-10.895,4.235,4.235,0,0,0,3-4.126V5.973a4.246,4.246,0,0,0-1.244-3l-1.541-1.541a4.247,4.247,0,0,0-3-1.244Z",
    transform: "translate(-97.603 -0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57-3",
    "data-name": "Path 57",
    className: "cls-4",
    d: "M651.829,1.428a4.246,4.246,0,0,0-3-1.244H637.8a4.246,4.246,0,0,0-3,1.244L633.261,2.97a4.245,4.245,0,0,0-1.244,3V17.657a4.236,4.236,0,0,0,3,4.127,11.3,11.3,0,0,1,8.3,10.895v5.65a4.247,4.247,0,0,0,4.247,4.247h1.263a4.246,4.246,0,0,0,3-1.244l1.542-1.541a4.25,4.25,0,0,0,1.243-3V5.972a4.248,4.248,0,0,0-1.243-3Z",
    transform: "translate(-102.504 -0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58-3",
    "data-name": "Path 58",
    className: "cls-4",
    d: "M613.095,63.928v-5.65a4.246,4.246,0,0,0-4.247-4.247h-1.263a4.243,4.243,0,0,0-3,1.244l-1.542,1.541a4.247,4.247,0,0,0-1.244,3V90.634a4.247,4.247,0,0,0,1.244,3l1.542,1.542a4.248,4.248,0,0,0,3,1.243H618.6a4.249,4.249,0,0,0,3-1.243l1.541-1.542a4.246,4.246,0,0,0,1.244-3V78.949a4.236,4.236,0,0,0-3-4.126,11.3,11.3,0,0,1-8.3-10.895",
    transform: "translate(-97.603 -8.763)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59-3",
    "data-name": "Path 59",
    className: "cls-4",
    d: "M647.562,54.031a4.247,4.247,0,0,0-4.247,4.247v5.65a11.3,11.3,0,0,1-8.3,10.895,4.236,4.236,0,0,0-3,4.126V90.634a4.246,4.246,0,0,0,1.244,3l1.542,1.542a4.246,4.246,0,0,0,3,1.243h11.021a4.246,4.246,0,0,0,3-1.243l1.542-1.542a4.246,4.246,0,0,0,1.244-3V59.819a4.246,4.246,0,0,0-1.244-3l-1.542-1.541a4.243,4.243,0,0,0-3-1.244Z",
    transform: "translate(-102.504 -8.763)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60-3",
    "data-name": "Path 60",
    className: "cls-4",
    d: "M627.217,123.985H613.6a10.971,10.971,0,0,0-10.97,10.97V196.53a4.148,4.148,0,0,0,4.148,4.148h32.586a4.148,4.148,0,0,0,4.148-4.148V140.281a4.149,4.149,0,0,0-1.215-2.933L630.15,125.2a4.151,4.151,0,0,0-2.933-1.215M615.06,161.5a7.853,7.853,0,1,1,6.512-6.513,7.858,7.858,0,0,1-6.512,6.513m0-18.47a7.853,7.853,0,1,1,6.513-6.513,7.858,7.858,0,0,1-6.513,6.513",
    transform: "translate(-97.738 -20.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61-3",
    "data-name": "Path 61",
    className: "cls-4",
    d: "M680.264,13.384v26.98A4.154,4.154,0,0,0,681.48,43.3l2.569,2.569a4.153,4.153,0,0,1,1.217,2.937V161.684a4.156,4.156,0,0,1-1.156,2.876l-2.689,2.8a4.157,4.157,0,0,0-1.156,2.876v5.9a4.154,4.154,0,0,0,4.154,4.154h35.437a4.154,4.154,0,0,0,4.154-4.154V169.76a4.154,4.154,0,0,0-1.216-2.937l-13.749-13.749a4.157,4.157,0,0,1-1.216-2.937V38.535a4.154,4.154,0,0,0-1.216-2.937l-9.372-9.372a4.153,4.153,0,0,1-1.217-2.937V4.339A4.154,4.154,0,0,0,691.868.185h-7.45a4.154,4.154,0,0,0-4.154,4.154Z",
    transform: "translate(-110.329 -0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62-3",
    "data-name": "Path 62",
    className: "cls-4",
    d: "M720.379,152.9l-2.7-2.7a4.433,4.433,0,0,1-1.3-3.135V35.929a4.437,4.437,0,0,0-1.3-3.135l-9.587-9.587a4.431,4.431,0,0,1-1.3-3.135V4.619A4.433,4.433,0,0,1,708.626.185h23a4.433,4.433,0,0,1,4.434,4.434V126.891a4.434,4.434,0,0,1-1.3,3.135l-5.45,5.451a4.434,4.434,0,0,0-1.3,3.11l-.062,11.2a4.434,4.434,0,0,1-7.569,3.111",
    transform: "translate(-114.21 -0.03)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup37);
export default __webpack_public_path__ + "static/media/Group 37.7842cef64c7c43e85ff486d6cd5e9f57.svg";
export { ForwardRef as ReactComponent };